import { Component, type ErrorInfo, type ReactNode } from 'react'

type Props = {
  children: ReactNode
}

type State = {
  failed: boolean
}

export class SceneErrorBoundary extends Component<Props, State> {
  state: State = { failed: false }

  static getDerivedStateFromError(): State {
    return { failed: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('3D workspace failed to render', error, info.componentStack)
  }

  render() {
    if (this.state.failed) {
      return (
        <div className="scene-fallback" role="alert">
          <strong>3D 작업실을 불러오지 못했습니다.</strong>
          <p>브라우저의 하드웨어 가속과 WebGL 설정을 확인해 주세요.</p>
          <button onClick={() => window.location.reload()}>다시 시도</button>
        </div>
      )
    }
    return this.props.children
  }
}
